import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=568473ec&"
import script from "./spin.vue?vue&type=script&lang=js&"
export * from "./spin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports